import Vue from "vue";
import DateService from "@/services/DateService";

Vue.filter("daysUntil", function (untilDate: string): number {
  return DateService.getDaysUntil(untilDate);
});
